// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbList":"breadcrumbs_component_breadcrumbList__Ajmj8","linkButton":"breadcrumbs_component_linkButton__y2mT7","active":"breadcrumbs_component_active__IMnft"};